<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: "App",
    data() {
      return {}
    },
    methods: {}
  };
</script>

<style lang="less">
  .size {
    width: 100%;
    height: 100%;
  }

  html,
  body {
    .size;
    overflow: hidden;
    margin: 0;
    padding: 0;
  }

  #app {
    .size;
    // overflow: scroll;
    position: fixed;
    overflow-y: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  img {
    object-fit: scale-down;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue